const CV_SESSION_FORMATS = new Set(['SYNCHRONOUS', 'MIXED'])
const KNOWN_SESSION_FORMATS = new Set(['SYNCHRONOUS', 'MIXED', 'ASYNCHRONOUS'])
const KNOWN_PRODUCT_TYPES = new Set(['cv', 'mix'])

export const METROPOLE_CV_NOTE = 'Les classes virtuelles sont en heure de métropole.'

type ProductLike = { product_session_type?: string | null }
type SessionLike = {
  global_id?: string | null
  product_session?: { format?: string | null } | null
}

// A known format decides: synchronous or mixed shows the note, asynchronous hides it.
// A cv/mix product is the fallback only when the format is missing or unknown.
export function hasKnownCvDates(input: {
  product: ProductLike | null
  products?: ProductLike[]
  session: SessionLike | null
  sessions?: SessionLike[]
}): boolean {
  const sessions = input.sessions ?? []
  const selected =
    sessions.find((item) => item.global_id && item.global_id === input.session?.global_id) ?? input.session
  const format = selected?.product_session?.format
  const products = input.product ? [input.product] : input.products ?? []
  return format && KNOWN_SESSION_FORMATS.has(format)
    ? CV_SESSION_FORMATS.has(format)
    : products.some((product) => KNOWN_PRODUCT_TYPES.has(product.product_session_type ?? ''))
}
